<template lang='pug'>
  form.forms.coupon.component.container(@submit.prevent='make')
    close-button( @click.native='$emit("close")' )

    header.heading
      h3 {{ $t('Coupon Details') }}

    section.fields
      fieldset
        img(:src='item.image.src')
      
      fieldset
        h3 {{ item.title }}

      fieldset
        label {{ $t('Ends on') }} {{ new Date(item.end).toLocaleDateString() }}

      fieldset
        label {{ item.amount }}% Discount

      fieldset
        label {{ item.description }}

    //- footer
    //-   fieldset.centered-text
    //-     bf-button.wide(type='submit')
    //-       template(v-slot:text) {{ text }}
</template>

<script>
  import { db, str } from '@/main'
  import CloseButton from '@/components/buttons/close'

  export default {
    name: 'forms.coupon',

    components: {
      CloseButton
    },

    props: {
      biz: { required: true},
      user: { type: Object, required: true },
      account: { type: Object, required: true },
      item: { type: Object, required: true }
    },

    data() {
      return {
        text: this.$t('Create'),
        key: 0
      }
    },

    methods: {
      make() {
        this.text = 'Creating...'
        let file = this.$refs.upload.files[0]
        let ref = str.ref(`/coupons/${this.user.uid}/${file.name}`)
        ref.put(file).then( snap =>
          snap.ref.getDownloadURL().then( url => 
            db.collection( 'coupons' ).add({ 
              image: {src: url}, 
              uid: this.user.uid, 
              account: this.account, 
              biz: this.biz, 
              ...this.item 
            }).then( doc => {
              this.item = { type: 'discount' }
              this.image = { src: 'no-image.png' }
              this.text='Create'
              this.$emit( 'close' )
            })
          )
        )
      },

      upload(e) {
        Array.from( e.target.files ).forEach( file => {
          let reader  = new FileReader()
          reader.addEventListener('load', () => {
            this.image = { src: reader.result } 
            this.$emit('changed')
          }, false)
          reader.readAsDataURL(file)
        })
      },

      del(image, i) {
        db.collection( this.collection ).doc( this.pid ).collection( 'images' ).doc( image.id ).delete()
      }
    }
  }
</script>

<style scoped lang="stylus">
  .forms.coupon
    background white
    border-radius 9px
    min-width 400px
    max-width 420px
    @media( max-width: 480px )
      min-width 0

    header
      padding 16px 32px
      background rgba( 0 0 0 .1 )
      border-bottom 1px solid rgba( 0 0 0 .25 )

    footer
      border-top 1px solid rgba( 0 0 0 .25 )

    header, footer
      box-shadow var(--shadow-box-shallow)

    section
      max-height calc( 100vh - 130px )
      overflow-y auto

    fieldset
      padding 16px 32px

    label
      display block
      font-weight bold
      margin 8px 2px
      &:first-child 
        margin-top 0
    
    .fields-container
      display grid
      grid-template-columns repeat( auto-fit, minmax( 192px, 1fr ) )
      fieldset:last-child
        // text-align right
        
    .image.container
      margin-left auto
      width 100%
      border-radius 13px
      overflow hidden
      // border 2px solid rgba( 0 0 0 .25 )
      box-shadow var(--shadow-box-shallow)
      @media( max-width: 383px )
        margin 0 auto
    .delete
      position absolute
      font-size 1.5em
      color white
      padding 8px 12px
      background rgba( 0 0 0 .25 )
      top 0
      right 0
      border-radius 0 0 0 13px
      box-shadow var(--shadow-box-shallow)
    img 
      object-fit cover
      width 100%
      display block

    
    .close
      position absolute
      right -6px
      top -6px
      background white
</style>